import { IconAssetDefaultStyled } from "./styled/IconStyled";
import { IIconAssetProps } from "./Icon.t";

function IconAssetDefault(props: IIconAssetProps) {
    const {
        size = '1.5em',
        height = "1em",
        symbol,
        width = "1em",
        ...iconProps
    } = props;
    return <IconAssetDefaultStyled
            style={{
                width: width,
                height: height,
                borderRadius: size,
                display: "inline-flex",
                fontSize: size,
            }}
            {...iconProps}
    >
        <span>{symbol?.charAt(0)}</span>
    </IconAssetDefaultStyled>
}

export default IconAssetDefault;
